import { Typography } from '@mui/material';

import { AppGridContainer, AppGridContent } from '../app-grid';

//
//

const NoDataChart: React.FC<{ text: string; Placeholder?: React.FC }> = ({ text, Placeholder }) => {
  return (
    <AppGridContainer
      spacing={{ sm: 4 }}
      sx={{
        justifyContent: 'center',
        alignItems: 'center',
        py: { xs: 4, md: 8 },
        px: 2,
      }}
    >
      <AppGridContent size={{ xs: 12, sm: Placeholder ? 7 : 12 }} textAlign={'center'}>
        <Typography variant="h5" gutterBottom>No data yet</Typography>
        <Typography>{text}</Typography>
      </AppGridContent>
      {Placeholder && (
        <AppGridContent size={{ xs: 12, sm: 5 }} display={'flex'} justifyContent={'flex-end'} sx={{ width: '100%' }}>
          <Placeholder />
        </AppGridContent>
      )}
    </AppGridContainer>
  );
};

export default NoDataChart;
